
import moment from "moment";

const getLastDateOfMonth = () => {
    const endOfMonth = moment().endOf('month').format('YYYY.MM.DD');
    return endOfMonth;
};
export default getLastDateOfMonth;